export default __webpack_public_path__ + "static/media/2030.f2a20c3e.png";